<template>
    <SaPageLayout class="sa-no-space" btnRefreshVisible @refresh="onRefreshRichieste">
        <template slot="toolbar">
            <b-button variant="outline-primary btn-toolbar sa-margin-right float-sm-right" @click="onBackToList">
                <b-icon icon="list"></b-icon>
                Lista Pratiche
            </b-button>
        </template>
        <template slot="table-filter"></template>
        <template slot="table-body">
            <SiatNotificheListaComponent ref="cmpSiatNoticheListaComponent" />
        </template>
    </SaPageLayout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SiatNotificheListaComponent from "../components/SiatNotificheListaComponent.vue"
export default {
    components: { SaPageLayout, SiatNotificheListaComponent },

    methods: {
        onBackToList() {
            this.$router.push("/pratichesiat")
        },
        onRefreshRichieste() {
            this.$refs.cmpSiatNoticheListaComponent.loadData();
        }
    }
}
</script>

<style lang="scss" scoped></style>